import {sync} from "vuex-pathify";
import Vue from "vue";

Vue.mixin({
	computed: {
		appLoading: sync('app.loading'),
	}
})